import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from 'vue';
import DataExporter from './Exporter/DataExporter.vue';
import {
    BFilter,
    BFilterOptions,
    BFilterOperation,
    BFilterableField,
    describeFilters,
listOperations,
textOperations,
} from "./BFilterEditor/BFilterEditor.types";
import { useCommunityPolicingStore } from '../stores/communityPolicingStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommunityPolicingDataExporter',
  props: {
    title: {},
    onlyHasOneOri: { type: Boolean },
    cancelUrl: {},
    submitUrl: {}
  },
  setup(__props: any) {


const props = __props;

const communityPolicingStore = useCommunityPolicingStore();
const dateRangeFrom = ref([] as Date[]);
const filterInfo = ref({ filters: [] } as BFilterOptions);

const filterableFields = computed(() => {
    let data = [] as BFilterableField[];

    if (!props.onlyHasOneOri) {
        data.push({
            property: "agency",
            label: "Agency",
            operations: listOperations,
            editorComponent: "list-editor",
            editorOptions: communityPolicingStore.getOrisAsBFieldSelectionArray
        });
    }   

    data.push(
        {
            property: "incidentNumber",
            label: 'Stop Number',
            operations: textOperations,
            editorComponent: "text-editor",
        },
        /* I'm leaving the corrected versions of these two filters in place in the off chance we change our minds about removing them. 
          I wanted the committed files to contain the correct filter options. This commented code should be removed at a later date 
        {
            property: "uploadedBy",
            label: "Uploaded By",
            operations: textOperations,
            editorComponent: "text-editor",
        },
        {
            property: "fileName",
            label: "File Name",
            operations: textOperations,
            editorComponent: "text-editor"
        }*/);
        
        return data;
});

var exportUrl = ref(generateExportUrl());

function generateExportUrl() {
    return communityPolicingStore.getExportUrl(dateRangeFrom.value, filterInfo.value, filterableFields.value)
};

function handleDateRangeUpdate(newDateRange: Date[]) {
    dateRangeFrom.value = newDateRange;
    exportUrl.value = generateExportUrl();
}

function handleFilterInfoUpdate(newFilterInfo: BFilterOptions) {
    filterInfo.value = newFilterInfo;
    exportUrl.value = generateExportUrl();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataExporter, {
    title: __props.title,
    "only-has-one-ori": __props.onlyHasOneOri,
    "cancel-url": __props.cancelUrl,
    "submit-url": __props.submitUrl,
    "export-url": _unref(exportUrl),
    "filterable-fields": filterableFields.value,
    onDateRangeUpdate: handleDateRangeUpdate,
    onFilterInfoUpdate: handleFilterInfoUpdate
  }, null, 8, ["title", "only-has-one-ori", "cancel-url", "submit-url", "export-url", "filterable-fields"]))
}
}

})